export default "__VITE_ASSET__CSC6qKaQ__"